export default __webpack_public_path__ + "images/juvo-logo-white.59523421034f2cbdc8ac8b685f84e642.png";